import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { DiagStackOtxActions } from './diag-stack-otx.actions';
import { OtxProcedureFileName } from './diag-stack-otx.model';
import { DiagStackOtxState } from './diag-stack-otx.state';

export const initDiagStackOtxState: DiagStackOtxState = {
  availableOtxSequences: null,
  availableOtxSequencesError: null,
  availableOtxSequencesLoading: false,
  otxGetDTCErrorSettingConditionResult: null,
  otxGetDTCErrorSettingConditionError: null,
  otxGetDTCErrorSettingConditionLoading: false,
  otxBackupConfigurationResult: null,
  otxBackupConfigurationLoading: false,
  otxBackupConfigurationAsyncSchedulerId: null,
  otxBackupConfigurationError: null,
  otxRestoreConfigurationResult: null,
  otxRestoreConfigurationLoading: false,
  otxRestoreConfigurationAsyncSchedulerId: null,
  otxRestoreConfigurationError: null,
};

export const diagStackOtxReducer: ActionReducer<DiagStackOtxState, Action> = createReducer(
  initDiagStackOtxState,
  on(
    DiagStackOtxActions.getAvailableOtxSequences.attempt,
    (state): DiagStackOtxState => ({
      ...state,
      availableOtxSequences: null,
      availableOtxSequencesError: null,
      availableOtxSequencesLoading: true,
    })
  ),
  on(
    DiagStackOtxActions.getAvailableOtxSequences.error,
    (state, { availableOtxSequencesError }): DiagStackOtxState => ({
      ...state,
      availableOtxSequences: null,
      availableOtxSequencesError,
      availableOtxSequencesLoading: false,
    })
  ),
  on(
    DiagStackOtxActions.getAvailableOtxSequences.success,
    (state, { availableOtxSequences }): DiagStackOtxState => ({
      ...state,
      availableOtxSequences,
      availableOtxSequencesError: null,
      availableOtxSequencesLoading: false,
    })
  ),
  on(
    DiagStackOtxActions.getAvailableOtxSequences.sequenceMissing,
    (state): DiagStackOtxState => ({
      ...state,
      availableOtxSequencesError:
        OtxProcedureFileName.DTCErrorSettingCondition + ' is missing in available sequences',
    })
  ),
  on(
    DiagStackOtxActions.executeOtx_GetDTCErrorSettingCondition.attempt,
    (state): DiagStackOtxState => ({
      ...state,
      otxGetDTCErrorSettingConditionResult: null,
      otxGetDTCErrorSettingConditionError: null,
      otxGetDTCErrorSettingConditionLoading: true,
    })
  ),
  on(
    DiagStackOtxActions.executeOtx_GetDTCErrorSettingCondition.error,
    (state, { otxGetDTCErrorSettingConditionError }): DiagStackOtxState => ({
      ...state,
      otxGetDTCErrorSettingConditionResult: null,
      otxGetDTCErrorSettingConditionError,
      otxGetDTCErrorSettingConditionLoading: false,
    })
  ),
  on(
    DiagStackOtxActions.executeOtx_GetDTCErrorSettingCondition.success,
    (state, { otxGetDTCErrorSettingConditionResult }): DiagStackOtxState => ({
      ...state,
      otxGetDTCErrorSettingConditionResult,
      otxGetDTCErrorSettingConditionError: null,
      otxGetDTCErrorSettingConditionLoading: false,
    })
  ),
  on(
    DiagStackOtxActions.executeOtx_BackupConfiguration.attempt,
    (state): DiagStackOtxState => ({
      ...state,
      otxBackupConfigurationResult: null,
      otxBackupConfigurationError: null,
      otxBackupConfigurationLoading: true,
      otxBackupConfigurationAsyncSchedulerId: null,
    })
  ),
  on(
    DiagStackOtxActions.executeOtx_BackupConfiguration.invokeStatusCheck,
    (state, { otxBackupConfigurationAsyncSchedulerId }): DiagStackOtxState => ({
      ...state,
      otxBackupConfigurationResult: null,
      otxBackupConfigurationError: null,
      otxBackupConfigurationLoading: true,
      otxBackupConfigurationAsyncSchedulerId,
    })
  ),
  on(
    DiagStackOtxActions.executeOtx_BackupConfiguration.error,
    (state, { otxBackupConfigurationError }): DiagStackOtxState => ({
      ...state,
      otxBackupConfigurationResult: null,
      otxBackupConfigurationError,
      otxBackupConfigurationLoading: false,
      otxBackupConfigurationAsyncSchedulerId: null,
    })
  ),
  on(
    DiagStackOtxActions.executeOtx_BackupConfiguration.success,
    (state, { otxBackupConfigurationResult }): DiagStackOtxState => ({
      ...state,
      otxBackupConfigurationResult,
      otxBackupConfigurationError: null,
      otxBackupConfigurationLoading: false,
      otxBackupConfigurationAsyncSchedulerId: null,
    })
  ),
  on(
    DiagStackOtxActions.executeOtx_RestoreConfiguration.attempt,
    (state): DiagStackOtxState => ({
      ...state,
      otxRestoreConfigurationResult: null,
      otxRestoreConfigurationError: null,
      otxRestoreConfigurationLoading: true,
      otxRestoreConfigurationAsyncSchedulerId: null,
    })
  ),
  on(
    DiagStackOtxActions.executeOtx_RestoreConfiguration.invokeStatusCheck,
    (state, { otxRestoreConfigurationAsyncSchedulerId }): DiagStackOtxState => ({
      ...state,
      otxBackupConfigurationResult: null,
      otxBackupConfigurationError: null,
      otxBackupConfigurationLoading: true,
      otxRestoreConfigurationAsyncSchedulerId,
    })
  ),
  on(
    DiagStackOtxActions.executeOtx_RestoreConfiguration.error,
    (state, { otxRestoreConfigurationError }): DiagStackOtxState => ({
      ...state,
      otxRestoreConfigurationResult: null,
      otxRestoreConfigurationError,
      otxRestoreConfigurationLoading: false,
      otxRestoreConfigurationAsyncSchedulerId: null,
    })
  ),
  on(
    DiagStackOtxActions.executeOtx_RestoreConfiguration.success,
    (state, { otxRestoreConfigurationResult }): DiagStackOtxState => ({
      ...state,
      otxRestoreConfigurationResult,
      otxRestoreConfigurationError: null,
      otxRestoreConfigurationLoading: false,
      otxRestoreConfigurationAsyncSchedulerId: null,
    })
  )
);
